// extracted by mini-css-extract-plugin
export default {"header":"Header_header__Mw-YK","sidebar":"Header_sidebar__2LRrt","sidebarToggleButton":"Header_sidebarToggleButton__WF00y"};